import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import RipsApi from '../api/RipsApi';
import Spinner from 'react-bootstrap/Spinner';

const ListRipsActions = ({ data, state }) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

    }, []);

    const downloadRIP = async (id_rip, numero_envio) => {
        setIsLoading(true);
        await RipsApi.descargarRIPSRegistrados(id_rip).then(response => {
            let blob = response;
            if (blob != null) {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = numero_envio + ".zip";
                document.body.appendChild(a);
                a.click();
                a.remove();
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                alert("Ha ocurrido un error descargando los RIPS de este registro");
            }
        }).catch(err => {
            alert("Ha ocurrido un error descargando los RIPS de este registro");
            console.log(err);
            setIsLoading(false);
        });
    }

    return (<Fragment>
        <td role="cell">
            {isLoading ? (<Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" />) :
                <Tooltip title="Descargar RIPS">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => {
                        downloadRIP(data.data.original.id_rip, data.data.original.numero_envio);
                    }}>
                        <FontAwesomeIcon icon={faDownload} />
                    </IconButton>
                </Tooltip>
            }
        </td>

    </Fragment>)
}

export default ListRipsActions;